const data = [
    { id: 1, name: 'Alteração de classe' },
    { id: 2, name: 'Pagamento integral por terceiro em processo judicial' },
    { id: 3, name: 'Pagamento parcial por terceiro em processo judicial' },
    { id: 4, name:  'Pagamento integral pelas Recuperandas em processo judicial' },
    { id: 5, name: 'Pagamento parcial pelas Recuperandas em processo judicial' },
    { id: 6, name: 'Bloqueio sem liberação em processo judicial'},
    { id: 7, name: 'Iliquido ou Incluir FGTS' },
    { id: 8, name: 'Bloqueio/Pagamento/Penhora' },
    { id: 9, name: 'Consta do sistema de AJ que a habilitação foi rejeitada - trabalhista/Iliquido ou Incluir FGTS' },
    { id: 10, name: 'Certidão de Crédito' },
    { id: 11, name: 'Incluir FGTS' },
    { id: 12, name: 'Sentença de liquidação transitada em julgado' },
    { id: 13, name: 'Iliquido' },
    { id: 14, name: 'Nome errado - Iliquido ou Incluir FGTS' },
    { id: 15, name: 'Não se sabe o motivo da alteração do valor' },
    { id: 16, name: 'Nome errado' },
    { id: 17, name: 'Incluir / Sistema AJ foi aprovado/Não consta da lista AJ/Sentença de liquidação' },
    { id: 18, name: 'Pedido de Hab não localizado no sistema AJ' },
    { id: 19, name: 'quirografário' },
    { id: 20, name: 'Incluir / Sistema AJ foi aprovado/Não consta da lista AJ/Incluir GTS' },
    { id: 21, name: 'Consta do sistema de AJ que a habilitação foi rejeitada - trabalhista' },
    { id: 22, name: 'Iliquido/Sem justificativa o valor' },
    { id: 23, name: 'Incluir' },
    { id: 24, name: 'Nome errado/Iliquido'},
    { id: 25, name: 'Incluir/Certidão de Crédito' },
    { id: 26, name: 'Iliquido/Cálculo não homologado' },
    { id: 27, name: 'Falta acrescentar TRCT da 123' },
    { id: 28, name: 'Excluir' },
    { id: 29, name: 'Incluir / Sistema AJ foi aprovado/Não consta da lista AJ/Incluir FGTS' },
    { id: 30, name: 'Ilíquido' },
]

export default [...data];